<h3 class="title configurator-title">{{ 'carpentry.summary.title' | translate }}</h3>

<ng-casto-loader *ngIf="loader"></ng-casto-loader>

<ng-casto-shopping-cart
  *ngIf="!loader"
  [shoppingCartService]="carpentryService"
  [shoppingCartProductList]="productsList"
  [discounts]="discounts"
  [order]="getLastOrder()"
  [configurationHasChanged]="configuration.configurationHasChanged"
  [refresh]="refresh"
  [selectedAssistances]="selectedAssistances"
  (previous)="previousStep($event)"
  (productListUpdate)="productListUpdate($event)"
  (refreshFinished)="refreshFinishedSet()"
  (configurationHasChangedUpdate)="updateConfigurationHasChanged($event)">
</ng-casto-shopping-cart>
